import { Badge, Flex } from "@radix-ui/themes";
import { ThumbsUp, ThumbsDown, Minus } from "lucide-react";
import { ReleaseConversationFeedback } from "@/v2/entities/release-conversation/ReleaseConversation.model";

interface FeedbackFormatterProps {
  value: ReleaseConversationFeedback;
}

export const FeedbackFormatter = ({ value }: FeedbackFormatterProps) => {
  if (value === "POSITIVE") {
    return (
      <Badge color="green" variant="soft" size="1">
        <Flex gap="1" align="center">
          <ThumbsUp size={12} />
          Positive
        </Flex>
      </Badge>
    );
  }

  if (value === "NEGATIVE") {
    return (
      <Badge color="red" variant="soft" size="1">
        <Flex gap="1" align="center">
          <ThumbsDown size={12} />
          Negative
        </Flex>
      </Badge>
    );
  }

  if (value === "FORGOTTEN") {
    return (
      <Badge color="bronze" variant="soft" size="1">
        <Flex gap="1" align="center">
          <Minus size={12} />
          Forgotten
        </Flex>
      </Badge>
    );
  }

  // For "NONE" or any other value, return null so it falls back to CategoryFormatter
  return null;
};
